import { Injectable, inject } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { SharedUserService } from '@agroone-front/shared'
import { RegionNetworkService } from './region.network.service'
import { Region } from '@agroone/entities'

@Injectable({
  providedIn: 'root',
})
export class RegionService {
  private regionNetworkService = inject(RegionNetworkService)
  private userService = inject(SharedUserService)

  public regions: Observable<Region[]>

  private regionsSubject: BehaviorSubject<Region[]> = new BehaviorSubject<Region[]>([])
  get currentRegions(): Region[] {
    return this.regionsSubject.getValue()
  }

  constructor() {
    this.regions = this.regionsSubject.asObservable()
  }

  init(): Observable<Region[]> {
    return this.getRegions()
  }

  getRegions(): Observable<Region[]> {
    return this.regionNetworkService.get().pipe(
      map((regions: Region[]) => {
        if (regions) {
          this.regionsSubject.next(regions)
        }
        return regions
      }),
    )
  }

  get currentActiveRegion(): Region | undefined {
    return this.currentRegions.find((region: Region) => region.name === this.userService.currentUser?.regionName)
  }
}
